import { parseSubscriptionStartedAtMs } from "@/features/subscriptions"
import { useSubscriptionStore } from "@/stores/subscription-store"

import { hasShownReviewModal } from "../persistence/review-modal-seen"

const WINDOW_MS = 30 * 60 * 1000

/** True if the review modal hasn't been shown and the main purchase started ≤30 min ago. */
export function shouldShowReviewModal(): boolean {
  if (hasShownReviewModal()) return false
  const startedAt = useSubscriptionStore.getState().subscription?.startedAt
  if (!startedAt) return false
  const startedAtMs = parseSubscriptionStartedAtMs(startedAt)
  if (!Number.isFinite(startedAtMs)) return false
  return Date.now() - startedAtMs <= WINDOW_MS
}
